import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CORE_RECURRING_GOAL_SCHEDULES_URL } from '../../constants/urls';
import RecurringGoalScheduleType from '../../domain/recurringGoalSchedule';

// This could be renamed to 'cascade_core_recurring_task_schedules'
// and take a 'force_update' parameter if the backend was changed to accept it.
function addNewCoreRecurringGoalSchedules(teamToFilter: number, filterToFcpIds?: number[]) {
  const requestConfig = {
    params: {
      team: teamToFilter,
      fcps: filterToFcpIds
    },
  } as AxiosRequestConfig;
  const EMPTY_DATA_OBJECT = {};
  return axios.post<any, AxiosResponse<RecurringGoalScheduleType[]>>(
    `${CORE_RECURRING_GOAL_SCHEDULES_URL}/cascade/`,
    EMPTY_DATA_OBJECT,
      requestConfig
  );
}

export {addNewCoreRecurringGoalSchedules}